import { ref } from 'vue';

export function useCountdown(timeInSeconds: number, callback: () => void | Promise<void>) {
  const timer = ref<NodeJS.Timeout>();
  const secondsRemaining = ref<number>(timeInSeconds);

  const initializeTimer = () => {
    // Clear any existing timer and reset countdown
    stopTimer();
    secondsRemaining.value = timeInSeconds;

    timer.value = setInterval(() => {
      secondsRemaining.value -= 1;
      if (secondsRemaining.value === 0) {
        stopTimer();
        callback();
      }
    }, 1000);
  };

  const stopTimer = () => {
    if (timer.value) {
      clearInterval(timer.value);
      timer.value = undefined;
    }
  };

  return { timer, initializeTimer, stopTimer, secondsRemaining };
}
